import PropTypes from "prop-types";
import React, { useState, useRef, useEffect } from "react";
import { getPhoenixFormVersion } from "requests/homeowner/caseforms";
import MSpinner from "components/Shared/MSpinner.tsx";
import Appraisal1004Desktop70DV1 from "components/Homeowner/CaseForms/Appraisal1004Desktop70D/V1/Appraisal1004Desktop70DV1";

export const Appraisal1004Desktop70D = props => {
  const mounted = useRef(true);

  const [version, setVersion] = useState(0);
  const [isFetchingVersion, setIsFetchingVersion] = useState(true);

  useEffect(() => {
    getPhoenixFormVersion(props.controlNumber, (payload) => {
      setVersion(payload);
      setIsFetchingVersion(false);
    }, mounted);
    return (() => { mounted.current = false; });
  }, []);

  if (isFetchingVersion) return <MSpinner />;

  let versionedComponents = [];
  versionedComponents[1] = Appraisal1004Desktop70DV1;
  versionedComponents["1"] = Appraisal1004Desktop70DV1;
  versionedComponents["PhoenixFormVersionNoneFound"] = Appraisal1004Desktop70DV1;
  let MyComponent = versionedComponents[version];
  if (!MyComponent) {
    throw new Error(`No corresponding 1004 Desktop/70D frontend version for backend version: ${version}`);
  }
  return (<MyComponent
    controlNumber={props.controlNumber}
    onChange={props.onChange}
    onSave={props.onSave}
    readOnly={props.readOnly}
  />);
};

Appraisal1004Desktop70D.propTypes = {
  controlNumber: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  readOnly: PropTypes.bool,
};

export default Appraisal1004Desktop70D;
